export type PushPlatform = 'android' | 'ios' | 'web'
export type PushPermission = 'prompt' | 'granted' | 'denied' | 'unsupported'
export type PushData = Record<string, unknown>
export interface PushMessage { title?: string; body?: string; data?: PushData }
export interface PushEvents {
  token: (token: string) => void
  received: (message: PushMessage) => void
  tap: (data: PushData) => void
  error: () => void
}
export interface PushAdapter {
  platform: PushPlatform
  initialize: (events: PushEvents) => Promise<void>
  permission: () => Promise<PushPermission>
  requestPermission: () => Promise<PushPermission>
  register: () => Promise<void>
  unregister: () => Promise<void>
  dispose: () => Promise<void>
}

export function safePushRoute(value: unknown): string | null {
  return typeof value === 'string' && /^\/(?:|services(?:\/[0-9]+)?|reservations|profile|info\/[a-zA-Z0-9_-]+)$/.test(value)
    ? value : null
}

export function pushPlatform(native: boolean, platform: string): PushPlatform {
  return native && (platform === 'android' || platform === 'ios') ? platform : 'web'
}
